import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress' // Progress 进度条
import store from '@/stores';

Vue.use(Router)

export let baseRoute = [{
        path: '/logining',
        menuName: '登录',
        component: (resolve) => require(['@/pages/login/login.vue'], resolve)
	}, {
        path: '/autoLogin',
        menuName: '登录',
        component: (resolve) => require(['@/pages/autoLogin.vue'], resolve)
	},
    {
        path: '/401',
        menuName: '无权访问',
        component: (resolve) => require(['@/pages/401.vue'], resolve)
	}, {
        path: '/404',
        menuName: '找不到页面',
        component: (resolve) => require(['@/pages/404.vue'], resolve)
    }, {
        name: 'dataPad',
        path: '/dataPad', //数据看板
        menuName: '数据看板',
        component: (resolve) => require(['@/pages/dataPad.vue'], resolve)
    }

]

let router = new Router({
    routes: baseRoute

})

router.beforeEach((to, from, next) => {
    // if (store.state.accesstoken === {} && store.state.info === {}) {
    //     next('/logining');
    //     return
    // }
    NProgress.start()
    next()
    NProgress.done()
})

router.afterEach(() => {
    NProgress.done() // 结束Progres
})
export default router



// WEBPACK FOOTER //
// ./src/routes/index.js